/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DemoRouteRouteImport } from './routes/demo/route'
import { Route as MrgolisodaRouteRouteImport } from './routes/mrgolisoda/route'
import { Route as SettingsRouteRouteImport } from './routes/settings/route'
import { Route as DemoIndexRouteImport } from './routes/demo/index'
import { Route as DevBridgeRouteImport } from './routes/dev/bridge'
import { Route as MrgolisodaIndexRouteImport } from './routes/mrgolisoda/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as SettingsOrgIdRouteImport } from './routes/settings/$orgId'
import { Route as MrgolisodaGpHomeIndexRouteImport } from './routes/mrgolisoda/gp-home/index'
import { Route as MrgolisodaMoreIndexRouteImport } from './routes/mrgolisoda/more/index'
import { Route as MrgolisodaMyBeatIndexRouteImport } from './routes/mrgolisoda/my-beat/index'
import { Route as MrgolisodaMyBeatIndex3RouteImport } from './routes/mrgolisoda/my-beat/index 3'
import { Route as MrgolisodaPreCheckoutIndexRouteImport } from './routes/mrgolisoda/pre-checkout/index'
import { Route as MrgolisodaMoreDayEndApprovalsIndexRouteImport } from './routes/mrgolisoda/more/day-end-approvals/index'
import { Route as MrgolisodaMoreMyFranchiseIndexRouteImport } from './routes/mrgolisoda/more/my-franchise/index'
import { Route as MrgolisodaOutletGpOutletIdIndexRouteImport } from './routes/mrgolisoda/outlet-gp/$outletId/index'
import { Route as MrgolisodaGpHomeBucketBucketKeyIndexRouteImport } from './routes/mrgolisoda/gp-home/bucket/$bucketKey/index'
import { Route as MrgolisodaMoreDayEndApprovalsApprovalIdIndexRouteImport } from './routes/mrgolisoda/more/day-end-approvals/$approvalId/index'
import { Route as MrgolisodaMoreMyFranchiseFranchiseIdIndexRouteImport } from './routes/mrgolisoda/more/my-franchise/$franchiseId/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoRouteRoute = DemoRouteRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => rootRouteImport,
} as any)
const MrgolisodaRouteRoute = MrgolisodaRouteRouteImport.update({
  id: '/mrgolisoda',
  path: '/mrgolisoda',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRouteRoute = SettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoIndexRoute = DemoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DemoRouteRoute,
} as any)
const DevBridgeRoute = DevBridgeRouteImport.update({
  id: '/dev/bridge',
  path: '/dev/bridge',
  getParentRoute: () => rootRouteImport,
} as any)
const MrgolisodaIndexRoute = MrgolisodaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MrgolisodaRouteRoute,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsOrgIdRoute = SettingsOrgIdRouteImport.update({
  id: '/$orgId',
  path: '/$orgId',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const MrgolisodaGpHomeIndexRoute = MrgolisodaGpHomeIndexRouteImport.update({
  id: '/gp-home/',
  path: '/gp-home/',
  getParentRoute: () => MrgolisodaRouteRoute,
} as any)
const MrgolisodaMoreIndexRoute = MrgolisodaMoreIndexRouteImport.update({
  id: '/more/',
  path: '/more/',
  getParentRoute: () => MrgolisodaRouteRoute,
} as any)
const MrgolisodaMyBeatIndexRoute = MrgolisodaMyBeatIndexRouteImport.update({
  id: '/my-beat/',
  path: '/my-beat/',
  getParentRoute: () => MrgolisodaRouteRoute,
} as any)
const MrgolisodaMyBeatIndex3Route = MrgolisodaMyBeatIndex3RouteImport.update({
  id: '/my-beat/index 3',
  path: '/my-beat/index 3',
  getParentRoute: () => MrgolisodaRouteRoute,
} as any)
const MrgolisodaPreCheckoutIndexRoute =
  MrgolisodaPreCheckoutIndexRouteImport.update({
    id: '/pre-checkout/',
    path: '/pre-checkout/',
    getParentRoute: () => MrgolisodaRouteRoute,
  } as any)
const MrgolisodaMoreDayEndApprovalsIndexRoute =
  MrgolisodaMoreDayEndApprovalsIndexRouteImport.update({
    id: '/more/day-end-approvals/',
    path: '/more/day-end-approvals/',
    getParentRoute: () => MrgolisodaRouteRoute,
  } as any)
const MrgolisodaMoreMyFranchiseIndexRoute =
  MrgolisodaMoreMyFranchiseIndexRouteImport.update({
    id: '/more/my-franchise/',
    path: '/more/my-franchise/',
    getParentRoute: () => MrgolisodaRouteRoute,
  } as any)
const MrgolisodaOutletGpOutletIdIndexRoute =
  MrgolisodaOutletGpOutletIdIndexRouteImport.update({
    id: '/outlet-gp/$outletId/',
    path: '/outlet-gp/$outletId/',
    getParentRoute: () => MrgolisodaRouteRoute,
  } as any)
const MrgolisodaGpHomeBucketBucketKeyIndexRoute =
  MrgolisodaGpHomeBucketBucketKeyIndexRouteImport.update({
    id: '/gp-home/bucket/$bucketKey/',
    path: '/gp-home/bucket/$bucketKey/',
    getParentRoute: () => MrgolisodaRouteRoute,
  } as any)
const MrgolisodaMoreDayEndApprovalsApprovalIdIndexRoute =
  MrgolisodaMoreDayEndApprovalsApprovalIdIndexRouteImport.update({
    id: '/more/day-end-approvals/$approvalId/',
    path: '/more/day-end-approvals/$approvalId/',
    getParentRoute: () => MrgolisodaRouteRoute,
  } as any)
const MrgolisodaMoreMyFranchiseFranchiseIdIndexRoute =
  MrgolisodaMoreMyFranchiseFranchiseIdIndexRouteImport.update({
    id: '/more/my-franchise/$franchiseId/',
    path: '/more/my-franchise/$franchiseId/',
    getParentRoute: () => MrgolisodaRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/demo': typeof DemoRouteRouteWithChildren
  '/mrgolisoda': typeof MrgolisodaRouteRouteWithChildren
  '/settings': typeof SettingsRouteRouteWithChildren
  '/dev/bridge': typeof DevBridgeRoute
  '/settings/$orgId': typeof SettingsOrgIdRoute
  '/demo/': typeof DemoIndexRoute
  '/mrgolisoda/': typeof MrgolisodaIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/mrgolisoda/my-beat/index 3': typeof MrgolisodaMyBeatIndex3Route
  '/mrgolisoda/gp-home/': typeof MrgolisodaGpHomeIndexRoute
  '/mrgolisoda/more/': typeof MrgolisodaMoreIndexRoute
  '/mrgolisoda/my-beat/': typeof MrgolisodaMyBeatIndexRoute
  '/mrgolisoda/pre-checkout/': typeof MrgolisodaPreCheckoutIndexRoute
  '/mrgolisoda/more/day-end-approvals/': typeof MrgolisodaMoreDayEndApprovalsIndexRoute
  '/mrgolisoda/more/my-franchise/': typeof MrgolisodaMoreMyFranchiseIndexRoute
  '/mrgolisoda/outlet-gp/$outletId/': typeof MrgolisodaOutletGpOutletIdIndexRoute
  '/mrgolisoda/gp-home/bucket/$bucketKey/': typeof MrgolisodaGpHomeBucketBucketKeyIndexRoute
  '/mrgolisoda/more/day-end-approvals/$approvalId/': typeof MrgolisodaMoreDayEndApprovalsApprovalIdIndexRoute
  '/mrgolisoda/more/my-franchise/$franchiseId/': typeof MrgolisodaMoreMyFranchiseFranchiseIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dev/bridge': typeof DevBridgeRoute
  '/settings/$orgId': typeof SettingsOrgIdRoute
  '/demo': typeof DemoIndexRoute
  '/mrgolisoda': typeof MrgolisodaIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/mrgolisoda/my-beat/index 3': typeof MrgolisodaMyBeatIndex3Route
  '/mrgolisoda/gp-home': typeof MrgolisodaGpHomeIndexRoute
  '/mrgolisoda/more': typeof MrgolisodaMoreIndexRoute
  '/mrgolisoda/my-beat': typeof MrgolisodaMyBeatIndexRoute
  '/mrgolisoda/pre-checkout': typeof MrgolisodaPreCheckoutIndexRoute
  '/mrgolisoda/more/day-end-approvals': typeof MrgolisodaMoreDayEndApprovalsIndexRoute
  '/mrgolisoda/more/my-franchise': typeof MrgolisodaMoreMyFranchiseIndexRoute
  '/mrgolisoda/outlet-gp/$outletId': typeof MrgolisodaOutletGpOutletIdIndexRoute
  '/mrgolisoda/gp-home/bucket/$bucketKey': typeof MrgolisodaGpHomeBucketBucketKeyIndexRoute
  '/mrgolisoda/more/day-end-approvals/$approvalId': typeof MrgolisodaMoreDayEndApprovalsApprovalIdIndexRoute
  '/mrgolisoda/more/my-franchise/$franchiseId': typeof MrgolisodaMoreMyFranchiseFranchiseIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/demo': typeof DemoRouteRouteWithChildren
  '/mrgolisoda': typeof MrgolisodaRouteRouteWithChildren
  '/settings': typeof SettingsRouteRouteWithChildren
  '/dev/bridge': typeof DevBridgeRoute
  '/settings/$orgId': typeof SettingsOrgIdRoute
  '/demo/': typeof DemoIndexRoute
  '/mrgolisoda/': typeof MrgolisodaIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/mrgolisoda/my-beat/index 3': typeof MrgolisodaMyBeatIndex3Route
  '/mrgolisoda/gp-home/': typeof MrgolisodaGpHomeIndexRoute
  '/mrgolisoda/more/': typeof MrgolisodaMoreIndexRoute
  '/mrgolisoda/my-beat/': typeof MrgolisodaMyBeatIndexRoute
  '/mrgolisoda/pre-checkout/': typeof MrgolisodaPreCheckoutIndexRoute
  '/mrgolisoda/more/day-end-approvals/': typeof MrgolisodaMoreDayEndApprovalsIndexRoute
  '/mrgolisoda/more/my-franchise/': typeof MrgolisodaMoreMyFranchiseIndexRoute
  '/mrgolisoda/outlet-gp/$outletId/': typeof MrgolisodaOutletGpOutletIdIndexRoute
  '/mrgolisoda/gp-home/bucket/$bucketKey/': typeof MrgolisodaGpHomeBucketBucketKeyIndexRoute
  '/mrgolisoda/more/day-end-approvals/$approvalId/': typeof MrgolisodaMoreDayEndApprovalsApprovalIdIndexRoute
  '/mrgolisoda/more/my-franchise/$franchiseId/': typeof MrgolisodaMoreMyFranchiseFranchiseIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/demo'
    | '/mrgolisoda'
    | '/settings'
    | '/dev/bridge'
    | '/settings/$orgId'
    | '/demo/'
    | '/mrgolisoda/'
    | '/settings/'
    | '/mrgolisoda/my-beat/index 3'
    | '/mrgolisoda/gp-home/'
    | '/mrgolisoda/more/'
    | '/mrgolisoda/my-beat/'
    | '/mrgolisoda/pre-checkout/'
    | '/mrgolisoda/more/day-end-approvals/'
    | '/mrgolisoda/more/my-franchise/'
    | '/mrgolisoda/outlet-gp/$outletId/'
    | '/mrgolisoda/gp-home/bucket/$bucketKey/'
    | '/mrgolisoda/more/day-end-approvals/$approvalId/'
    | '/mrgolisoda/more/my-franchise/$franchiseId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dev/bridge'
    | '/settings/$orgId'
    | '/demo'
    | '/mrgolisoda'
    | '/settings'
    | '/mrgolisoda/my-beat/index 3'
    | '/mrgolisoda/gp-home'
    | '/mrgolisoda/more'
    | '/mrgolisoda/my-beat'
    | '/mrgolisoda/pre-checkout'
    | '/mrgolisoda/more/day-end-approvals'
    | '/mrgolisoda/more/my-franchise'
    | '/mrgolisoda/outlet-gp/$outletId'
    | '/mrgolisoda/gp-home/bucket/$bucketKey'
    | '/mrgolisoda/more/day-end-approvals/$approvalId'
    | '/mrgolisoda/more/my-franchise/$franchiseId'
  id:
    | '__root__'
    | '/'
    | '/demo'
    | '/mrgolisoda'
    | '/settings'
    | '/dev/bridge'
    | '/settings/$orgId'
    | '/demo/'
    | '/mrgolisoda/'
    | '/settings/'
    | '/mrgolisoda/my-beat/index 3'
    | '/mrgolisoda/gp-home/'
    | '/mrgolisoda/more/'
    | '/mrgolisoda/my-beat/'
    | '/mrgolisoda/pre-checkout/'
    | '/mrgolisoda/more/day-end-approvals/'
    | '/mrgolisoda/more/my-franchise/'
    | '/mrgolisoda/outlet-gp/$outletId/'
    | '/mrgolisoda/gp-home/bucket/$bucketKey/'
    | '/mrgolisoda/more/day-end-approvals/$approvalId/'
    | '/mrgolisoda/more/my-franchise/$franchiseId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DemoRouteRoute: typeof DemoRouteRouteWithChildren
  MrgolisodaRouteRoute: typeof MrgolisodaRouteRouteWithChildren
  SettingsRouteRoute: typeof SettingsRouteRouteWithChildren
  DevBridgeRoute: typeof DevBridgeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo': {
      id: '/demo'
      path: '/demo'
      fullPath: '/demo'
      preLoaderRoute: typeof DemoRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mrgolisoda': {
      id: '/mrgolisoda'
      path: '/mrgolisoda'
      fullPath: '/mrgolisoda'
      preLoaderRoute: typeof MrgolisodaRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo/': {
      id: '/demo/'
      path: '/'
      fullPath: '/demo/'
      preLoaderRoute: typeof DemoIndexRouteImport
      parentRoute: typeof DemoRouteRoute
    }
    '/dev/bridge': {
      id: '/dev/bridge'
      path: '/dev/bridge'
      fullPath: '/dev/bridge'
      preLoaderRoute: typeof DevBridgeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mrgolisoda/': {
      id: '/mrgolisoda/'
      path: '/'
      fullPath: '/mrgolisoda/'
      preLoaderRoute: typeof MrgolisodaIndexRouteImport
      parentRoute: typeof MrgolisodaRouteRoute
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/$orgId': {
      id: '/settings/$orgId'
      path: '/$orgId'
      fullPath: '/settings/$orgId'
      preLoaderRoute: typeof SettingsOrgIdRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/mrgolisoda/gp-home/': {
      id: '/mrgolisoda/gp-home/'
      path: '/gp-home'
      fullPath: '/mrgolisoda/gp-home/'
      preLoaderRoute: typeof MrgolisodaGpHomeIndexRouteImport
      parentRoute: typeof MrgolisodaRouteRoute
    }
    '/mrgolisoda/more/': {
      id: '/mrgolisoda/more/'
      path: '/more'
      fullPath: '/mrgolisoda/more/'
      preLoaderRoute: typeof MrgolisodaMoreIndexRouteImport
      parentRoute: typeof MrgolisodaRouteRoute
    }
    '/mrgolisoda/my-beat/': {
      id: '/mrgolisoda/my-beat/'
      path: '/my-beat'
      fullPath: '/mrgolisoda/my-beat/'
      preLoaderRoute: typeof MrgolisodaMyBeatIndexRouteImport
      parentRoute: typeof MrgolisodaRouteRoute
    }
    '/mrgolisoda/my-beat/index 3': {
      id: '/mrgolisoda/my-beat/index 3'
      path: '/my-beat/index 3'
      fullPath: '/mrgolisoda/my-beat/index 3'
      preLoaderRoute: typeof MrgolisodaMyBeatIndex3RouteImport
      parentRoute: typeof MrgolisodaRouteRoute
    }
    '/mrgolisoda/pre-checkout/': {
      id: '/mrgolisoda/pre-checkout/'
      path: '/pre-checkout'
      fullPath: '/mrgolisoda/pre-checkout/'
      preLoaderRoute: typeof MrgolisodaPreCheckoutIndexRouteImport
      parentRoute: typeof MrgolisodaRouteRoute
    }
    '/mrgolisoda/more/day-end-approvals/': {
      id: '/mrgolisoda/more/day-end-approvals/'
      path: '/more/day-end-approvals'
      fullPath: '/mrgolisoda/more/day-end-approvals/'
      preLoaderRoute: typeof MrgolisodaMoreDayEndApprovalsIndexRouteImport
      parentRoute: typeof MrgolisodaRouteRoute
    }
    '/mrgolisoda/more/my-franchise/': {
      id: '/mrgolisoda/more/my-franchise/'
      path: '/more/my-franchise'
      fullPath: '/mrgolisoda/more/my-franchise/'
      preLoaderRoute: typeof MrgolisodaMoreMyFranchiseIndexRouteImport
      parentRoute: typeof MrgolisodaRouteRoute
    }
    '/mrgolisoda/outlet-gp/$outletId/': {
      id: '/mrgolisoda/outlet-gp/$outletId/'
      path: '/outlet-gp/$outletId'
      fullPath: '/mrgolisoda/outlet-gp/$outletId/'
      preLoaderRoute: typeof MrgolisodaOutletGpOutletIdIndexRouteImport
      parentRoute: typeof MrgolisodaRouteRoute
    }
    '/mrgolisoda/gp-home/bucket/$bucketKey/': {
      id: '/mrgolisoda/gp-home/bucket/$bucketKey/'
      path: '/gp-home/bucket/$bucketKey'
      fullPath: '/mrgolisoda/gp-home/bucket/$bucketKey/'
      preLoaderRoute: typeof MrgolisodaGpHomeBucketBucketKeyIndexRouteImport
      parentRoute: typeof MrgolisodaRouteRoute
    }
    '/mrgolisoda/more/day-end-approvals/$approvalId/': {
      id: '/mrgolisoda/more/day-end-approvals/$approvalId/'
      path: '/more/day-end-approvals/$approvalId'
      fullPath: '/mrgolisoda/more/day-end-approvals/$approvalId/'
      preLoaderRoute: typeof MrgolisodaMoreDayEndApprovalsApprovalIdIndexRouteImport
      parentRoute: typeof MrgolisodaRouteRoute
    }
    '/mrgolisoda/more/my-franchise/$franchiseId/': {
      id: '/mrgolisoda/more/my-franchise/$franchiseId/'
      path: '/more/my-franchise/$franchiseId'
      fullPath: '/mrgolisoda/more/my-franchise/$franchiseId/'
      preLoaderRoute: typeof MrgolisodaMoreMyFranchiseFranchiseIdIndexRouteImport
      parentRoute: typeof MrgolisodaRouteRoute
    }
  }
}

interface DemoRouteRouteChildren {
  DemoIndexRoute: typeof DemoIndexRoute
}

const DemoRouteRouteChildren: DemoRouteRouteChildren = {
  DemoIndexRoute: DemoIndexRoute,
}

const DemoRouteRouteWithChildren = DemoRouteRoute._addFileChildren(
  DemoRouteRouteChildren,
)

interface MrgolisodaRouteRouteChildren {
  MrgolisodaIndexRoute: typeof MrgolisodaIndexRoute
  MrgolisodaMyBeatIndex3Route: typeof MrgolisodaMyBeatIndex3Route
  MrgolisodaGpHomeIndexRoute: typeof MrgolisodaGpHomeIndexRoute
  MrgolisodaMoreIndexRoute: typeof MrgolisodaMoreIndexRoute
  MrgolisodaMyBeatIndexRoute: typeof MrgolisodaMyBeatIndexRoute
  MrgolisodaPreCheckoutIndexRoute: typeof MrgolisodaPreCheckoutIndexRoute
  MrgolisodaMoreDayEndApprovalsIndexRoute: typeof MrgolisodaMoreDayEndApprovalsIndexRoute
  MrgolisodaMoreMyFranchiseIndexRoute: typeof MrgolisodaMoreMyFranchiseIndexRoute
  MrgolisodaOutletGpOutletIdIndexRoute: typeof MrgolisodaOutletGpOutletIdIndexRoute
  MrgolisodaGpHomeBucketBucketKeyIndexRoute: typeof MrgolisodaGpHomeBucketBucketKeyIndexRoute
  MrgolisodaMoreDayEndApprovalsApprovalIdIndexRoute: typeof MrgolisodaMoreDayEndApprovalsApprovalIdIndexRoute
  MrgolisodaMoreMyFranchiseFranchiseIdIndexRoute: typeof MrgolisodaMoreMyFranchiseFranchiseIdIndexRoute
}

const MrgolisodaRouteRouteChildren: MrgolisodaRouteRouteChildren = {
  MrgolisodaIndexRoute: MrgolisodaIndexRoute,
  MrgolisodaMyBeatIndex3Route: MrgolisodaMyBeatIndex3Route,
  MrgolisodaGpHomeIndexRoute: MrgolisodaGpHomeIndexRoute,
  MrgolisodaMoreIndexRoute: MrgolisodaMoreIndexRoute,
  MrgolisodaMyBeatIndexRoute: MrgolisodaMyBeatIndexRoute,
  MrgolisodaPreCheckoutIndexRoute: MrgolisodaPreCheckoutIndexRoute,
  MrgolisodaMoreDayEndApprovalsIndexRoute:
    MrgolisodaMoreDayEndApprovalsIndexRoute,
  MrgolisodaMoreMyFranchiseIndexRoute: MrgolisodaMoreMyFranchiseIndexRoute,
  MrgolisodaOutletGpOutletIdIndexRoute: MrgolisodaOutletGpOutletIdIndexRoute,
  MrgolisodaGpHomeBucketBucketKeyIndexRoute:
    MrgolisodaGpHomeBucketBucketKeyIndexRoute,
  MrgolisodaMoreDayEndApprovalsApprovalIdIndexRoute:
    MrgolisodaMoreDayEndApprovalsApprovalIdIndexRoute,
  MrgolisodaMoreMyFranchiseFranchiseIdIndexRoute:
    MrgolisodaMoreMyFranchiseFranchiseIdIndexRoute,
}

const MrgolisodaRouteRouteWithChildren = MrgolisodaRouteRoute._addFileChildren(
  MrgolisodaRouteRouteChildren,
)

interface SettingsRouteRouteChildren {
  SettingsOrgIdRoute: typeof SettingsOrgIdRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteRouteChildren: SettingsRouteRouteChildren = {
  SettingsOrgIdRoute: SettingsOrgIdRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteRouteWithChildren = SettingsRouteRoute._addFileChildren(
  SettingsRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DemoRouteRoute: DemoRouteRouteWithChildren,
  MrgolisodaRouteRoute: MrgolisodaRouteRouteWithChildren,
  SettingsRouteRoute: SettingsRouteRouteWithChildren,
  DevBridgeRoute: DevBridgeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
